import React from 'react';
import Navbar from '../../components/navbar';
import CRUDEmpresas from '../../components/crudEmpresas';

function VistaDatosEmpresas() {
    return (
        <CRUDEmpresas />
    )
}

export default VistaDatosEmpresas;